export function getDefaultCron(cronFormatter, frequency) {
  const {
    NONE, DAILY, WEEKLY, MONTHLY, EVERY_6_HOURS, EVERY_12_HOURS,
  } = cronFormatter.getCronFrequenciesEnum();
  switch (frequency) {
    case NONE:
      return null;
    case DAILY:
      return '0 0 * * * *';
    case WEEKLY:
      return '0 0 * * 0 *';
    case MONTHLY:
      return '0 0 1 * * *';
    case EVERY_6_HOURS:
      return '0 */6 * * * *';
    case EVERY_12_HOURS:
      return '0 */12 * * * *';
    default:
      return null;
  }
}
